module.exports = __webpack_public_path__ + "assets/img/企业简介_07.956981df.jpg";